import React, {ReactElement} from 'react';
import {RedistributeOption} from './RedistributeOption';
import {SpendOption} from './SpendOption';

export const NewDayOptions = (): ReactElement => (
  <>
    <SpendOption />
    <RedistributeOption />
  </>
);
